import script from "./MobileDisciplinePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileDisciplinePage.vue?vue&type=script&lang=ts&setup=true"

import "./MobileDisciplinePage.vue?vue&type=style&index=0&id=553baece&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553baece"]])

export default __exports__